import React, { useState, useRef, useMemo, useEffect } from "react";
import ResourcesAndReusables from "./ResourcesAndReusables";
import ContentHeader from "../ContentHeader";
import List from "../List";
import Modal from "../Modal";
import NoContent from "../NoContent";
import UIGallery from "../UIGallery";
import Avatar from "../shared/Avatar.jsx";

import data from "../../../../_data/resources-and-reusables.json";

export default function UIDesignGallery() {
  const [projects, setProjects] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const selectedProject = useRef(null);

  useEffect(() => {
    let visibleProjects = [];

    if (data && data.projects) {
      visibleProjects = data.projects.filter((p) => p.isVisible);
    }

    setProjects(visibleProjects);
  }, []);

  if (!projects) return <NoContent message={"No projects found."} />;

  const filteredData = projects.filter((p) => p.prototypeUrl || p.gallery);

  if (!filteredData || filteredData.length < 1)
    return <NoContent message={"No project designs found."} />;

  return (
    <>
      <ResourcesAndReusables />

      <ContentHeader
        title={"UI Design Gallery"}
        caption={"A showcase of design prototypes used for projects."}
      />

      <List
        data={filteredData}
        itemsPerPage={3}
        itemNameKey={"title"}
        itemExcerptKey={"description"}
        itemCategoryKeys={["engagement", "subBU"]}
        itemFields={[
          {
            key: "status",
            label: "Status",
            type: "chip",
          },
          {
            key: "workType",
            label: "Work Type",
            type: "chip",
          },
        ]}
        listFilterKey={"status"}
        listFilterVals={[
          "IN PROGRESS",
          "NEW",
          "WAITING FOR FEEDBACK",
          "COMPLETED",
          "ON HOLD",
          "DUPLICATE",
        ]}
        dateFilterKey={"initiatedOn"}
        onItemClick={(project) => {
          selectedProject.current = project;
          setShowModal(true);
        }}
      />

      {showModal && (
        <Modal
          onClose={() => {
            selectedProject.current = null;
            setShowModal(false);
          }}
        >
          <ModalContent selectedProject={selectedProject.current} />
        </Modal>
      )}
    </>
  );
}

function ModalContent({ selectedProject }) {
  const assignees = useMemo(
    () => selectedProject.assignee.map((c) => <Avatar key={c} name={c} />),
    [],
  );

  return (
    <div className="gallery-modal-container">
      <h1>{selectedProject.title}</h1>

      <div className="project-info">
        <span className="assignee-span">
          {assignees}
          <h3>Assignees</h3>
        </span>
        <span
          style={{
            fontSize: "small",
          }}
        >
          <h3>Status</h3>
          <p
            style={{
              margin: "0px",
              padding: "0px",
              fontWeight: 500,
              color: statusLevelStyle(selectedProject.status),
            }}
          >
            {selectedProject.status}
          </p>
        </span>
        <span
          style={{
            height: "fit-content",
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            fontSize: "small",
          }}
        >
          <h3>Category:</h3>
          <p className="category-chip">{selectedProject.workType}</p>
        </span>
      </div>

      <UIGallery figmaSrc={selectedProject.prototypeUrl} images={selectedProject.gallery} />
    </div>
  );
}

function statusLevelStyle(status) {
  switch (status) {
    case "COMPLETED":
      return "green";
    case "IN PROGRESS":
      return "blue";
    case "ON HOLD":
      return "orange";
    case "WAITING FOR FEEDBACK":
      return "purple";
  }
}
